import { ReactComponent as NotFoundImage } from '@src/assets/images/not-found.svg';

export function NotFound() {
  return (
    <div className='flex flex-col items-center font-bold'>
      <NotFoundImage className='w-full max-h-[200]' />
      <span className='text-wl-on-surface'>No Result Found</span>
    </div>
  );
}
